import React from 'react';
import getConfig from 'next/config';

function AnalyticsLaunchScripts() {
  const { publicRuntimeConfig: { dev } } = getConfig();
  const launchScripts = {
    prod: '//assets.adobedtm.com/launch-EN03682f66064449c8b87d78eae3e2fc57.min.js',
    stage: '//assets.adobedtm.com/launch-EN73ef4bfbb64046d89ea9b8f64998688c-staging.min.js',
  };
  const launchSrc = dev ? launchScripts.stage : launchScripts.prod;

  return (
    <script src={launchSrc} />
  );
}

export default AnalyticsLaunchScripts;
